export class Generator {

  static randomKey() {
    return Math.random()
      .toString(36)
      .substr(2, 5);
  }

}
